<template>
  <div class="product-grid">
    <div class="d-flex justify-center mb-10">
      <h2>Products</h2>
      <p v-if="products.length === 0" class="no-products">
        No products found. Try adjusting your filters.
      </p>
    </div>
    
    <div class="grid">
      <product-card
        v-for="product in products"
        :key="product.id"
        :product="product"
        class="grid-item"
      />
    </div>
    
    <div v-if="products.length === 0" class="empty-state">
      <p>No products match your criteria. Try clearing filters.</p>
      <button @click="clearFilters" class="clear-filters-btn">
        Clear All Filters
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ProductCard from './ProductCard.vue'

export default {
  name: 'ProductGrid',
  components: {
    ProductCard
  },
  computed: {
    ...mapState({
      products: state => state.ecommerce.products.filteredProducts.length 
        ? state.ecommerce.products.filteredProducts 
        : state.ecommerce.products.products
    })
  },
  methods: {
    ...mapActions({
      clearFilters: 'ecommerce/products/clearFilters'
    })
  }
}
</script>

<style scoped>
.product-grid {
  padding: 20px 0;
}

.grid-header {
  margin-bottom: 30px;
}

.grid-header h2 {
  font-size: 28px;
  color: #333;
  margin: 0 0 10px 0;
}

.no-products {
  color: #666;
  font-size: 16px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 25px;
  margin: 20px;
}

.empty-state {
  text-align: center;
  padding: 40px;
  background: #f8f9fa;
  border-radius: 12px;
  margin-top: 40px;
}

.empty-state p {
  color: #666;
  font-size: 18px;
  margin-bottom: 20px;
}

.clear-filters-btn {
  padding: 12px 24px;
  background: #2ed573;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.clear-filters-btn:hover {
  background: #26c463;
  transform: translateY(-2px);
}

@media (max-width: 768px) {
  .grid {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 20px;
  }
  
  .grid-header h2 {
    font-size: 24px;
  }
}

@media (max-width: 480px) {
  .grid {
    grid-template-columns: 1fr;
  }
}
</style>